import React, { useEffect, useState } from 'react';
import { Formik, Form } from 'formik';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import HelmetComponent from '@/components/general/Helmet/HelmetComponent';
import * as Yup from 'yup';

const inputStyle = {
  width: '97.7%',
  padding: '22px 11px 10px',
  borderRadius: 6,
  border: '1px solid #E0E0E0',
  background: '#F3F3F3',
  outline: 'none',
  fontSize: 14,
};

const validationSchema = Yup.object({
  pais: Yup.object({
    codigo_de_pais: Yup.string().required('Seleccione un país'),
  }),
  departamento: Yup.object({
    codigo_departamento: Yup.string().required('Seleccione un departamento'),
    nombre: Yup.string(),
  }),
  provincia: Yup.object({
    codigo_provincia: Yup.string().required('Seleccione un provincia'),
    nombre: Yup.string(),
  }),
  distrito: Yup.object({
    codigo_de_distrito: Yup.string().required('Seleccione un distrito'),
    nombre: Yup.string(),
  }),

  direccion: Yup.string().required('Campo obligatorio'),
  fecha_nacimiento: Yup.string().required('Campo obligatorio'),
  sexo: Yup.string().required('Campo obligatorio'),
  password: Yup.string()
    .min(6, 'Mínimo 6 caracteres')
    .required('Campo obligatorio'),
  password_repeat: Yup.string()
    .oneOf([Yup.ref('password')], 'Las contraseñas no coinciden')
    .required('Campo obligatorio'),
  acepta_politicas: Yup.boolean().oneOf([true], 'Debes aceptar las políticas'),
});

const PatientDataView = props => {
  const {
    lenguage,
    paises,
    departamentos,
    provincias,
    distritos,
    patient,
    onSavePatient,
    onChangePassword,
  } = props;

  console.log('📦 PROPS PatientDataView:', {
    paises,
    departamentos,
    provincias,
    distritos,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const initialValues = {
    tipo_documento: patient?.tip_documento_pac ?? '',
    numero_de_dni: patient?.numero_de_dni ?? '',
    nombres: patient?.nombres ?? '',
    apellido_paterno: patient?.apellido_paterno ?? '',
    apellido_materno: patient?.apellido_materno ?? '',
    email: patient?.correo_electronico ?? '',
    celular: patient?.telefono_celular ?? '',
    pais: {
      codigo: paises?.codigo ?? '',
      codigo_de_pais: paises?.codigo_de_pais ?? '',
      descripcion_de_pais: paises?.descripcion_de_pais ?? '',
      fecha_de_registro: paises?.fecha_de_registro ?? '',
      hora_de_registro: paises?.hora_de_registro ?? '',
    },
    departamento: {
      codigo_departamento: '',
      nombre: '',
    },
    provincia: {
      codigo_provincia: '',
      nombre: '',
    },
    distrito: {
      codigo_de_distrito: '',
      nombre: '',
    },
    direccion: '',
    fecha_nacimiento: '',
    sexo: '',
    password: '',
    password_repeat: '',
    acepta_politicas: false,
    acepta_publicidad: false,
  };

  const buildPatientPayload = values => ({
    numero_de_dni: values.numero_de_dni,
    tipo_documento: values.tipo_documento,
    nombres: values.nombres,
    apellido_paterno: values.apellido_paterno,
    apellido_materno: values.apellido_materno,
    correo_electronico: values.email,
    telefono_celular: values.celular,
    direccion: values.direccion,
    repeat_pass: values.password_repeat,
    text_jp: values.password,
    pass: values.password,
    sexo: values.sexo,
    fecha_de_nacimiento: values.fecha_nacimiento,
    pais: {
      codigo_de_pais: values.pais.codigo_de_pais,
    },
    distrito: {
      codigo_de_distrito: values.distrito.codigo_de_distrito,
    },
    departamento: {
      codigo_de_provincial: values.departamento.codigo_departamento,
    },
    provincia: {
      codigo_de_estado_de_pais: values.provincia.codigo_provincia,
    },

    web: 'EXTERNO',
  });

  const handleSubmit = async values => {
    try {
      const payload = buildPatientPayload(values);
      await onSavePatient(payload);
      alert('Paciente actualizado o guardado correctamente');

      if (values.password) {
        try {
          await onChangePassword(values.numero_de_dni, values.password);
        } catch (error) {
          console.error('Error al cambiar contraseña:', error);
        }
      }
    } catch (error) {
      console.error('Error al actualizar o guardar paciente:', error);
      alert('Error al guardar paciente');
    }
  };

  return (
    <div
      className="App bgGradientBlueReverse"
      style={{ minHeight: '100vh', paddingTop: 120 }}
    >
      <HelmetComponent title="Mis Datos" />

      <FlexContainer
        className="flex-column width100 padtb40 padlr40 bgWhite borderrad20"
        style={{ maxWidth: 1100, margin: '0 auto' }}
      >
        <h2 style={{ color: '#023B7A', marginBottom: 24 }}>
          Ficha de filiación
        </h2>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            values,
            handleChange,
            handleBlur,
            errors,
            touched,
            setFieldValue,
          }) => (
            <Form>
              {/* TIPO DOCUMENTO */}
              <div
                style={{
                  position: 'relative',
                  marginBottom: 16,
                  width: '100%',
                }}
              >
                <label
                  style={{
                    position: 'absolute',
                    top: 6,
                    left: 12,
                    fontSize: 12,
                    color: '#8A8A8A',
                    zIndex: 2,
                  }}
                >
                  Tipo de documento*
                </label>

                <div style={{ position: 'relative', width: '100%' }}>
                  <select
                    name="tipo_documento"
                    disabled
                    value={values.tipo_documento}
                    style={{
                      width: '100%',
                      padding: '22px 0px 10px 11px',
                      borderRadius: 6,
                      border: '1px solid #E0E0E0',
                      background: '#F3F3F3',
                      fontSize: 14,
                      boxSizing: 'border-box',
                      appearance: 'none',
                      WebkitAppearance: 'none',
                      MozAppearance: 'none',
                    }}
                  >
                    <option value="D.N.I.">DNI</option>
                    <option value="C.E.">C.E.</option>
                    <option value="PASAPORTE">PASAPORTE</option>
                  </select>

                  {/* Flecha custom */}
                  <span
                    style={{
                      position: 'absolute',
                      right: 14,
                      top: '50%',
                      transform: 'translateY(-35%) rotate(270deg)',
                      fontSize: 20,
                      fontWeight: 900,
                      color: '#8A8A8A',
                      pointerEvents: 'none',
                    }}
                  >
                    ‹
                  </span>
                </div>
              </div>

              {/* NÚMERO DOCUMENTO */}
              <div
                style={{
                  position: 'relative',
                  marginBottom: 16,
                  width: '100%',
                }}
              >
                <label
                  style={{
                    position: 'absolute',
                    top: 6,
                    left: 12,
                    fontSize: 12,
                    color: '#8A8A8A',
                  }}
                >
                  Número de documento*
                </label>

                <input
                  type="text"
                  disabled
                  name="numero_de_dni"
                  value={values.numero_de_dni}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>

              {/* NOMBRES */}
              <div
                style={{
                  position: 'relative',
                  marginBottom: 16,
                  width: '100%',
                }}
              >
                <label
                  style={{
                    position: 'absolute',
                    top: 6,
                    left: 12,
                    fontSize: 12,
                    color: '#8A8A8A',
                  }}
                >
                  Nombres*
                </label>
                <input
                  type="text"
                  name="nombres"
                  disabled
                  value={values.nombres}
                  style={inputStyle}
                />
              </div>

              {/* APELLIDO PATERNO */}
              <div
                style={{
                  position: 'relative',
                  marginBottom: 16,
                  width: '100%',
                }}
              >
                <label
                  style={{
                    position: 'absolute',
                    top: 6,
                    left: 12,
                    fontSize: 12,
                    color: '#8A8A8A',
                  }}
                >
                  Apellido paterno*
                </label>
                <input
                  type="text"
                  name="apellido_paterno"
                  disabled
                  value={values.apellido_paterno}
                  style={inputStyle}
                />
              </div>

              {/* APELLIDO MATERNO */}
              <div
                style={{
                  position: 'relative',
                  marginBottom: 16,
                  width: '100%',
                }}
              >
                <label
                  style={{
                    position: 'absolute',
                    top: 6,
                    left: 12,
                    fontSize: 12,
                    color: '#8A8A8A',
                  }}
                >
                  Apellido materno*
                </label>
                <input
                  type="text"
                  name="apellido_materno"
                  disabled
                  value={values.apellido_materno}
                  style={inputStyle}
                />
              </div>

              {/* EMAIL */}
              <div
                style={{
                  position: 'relative',
                  marginBottom: 16,
                  width: '100%',
                }}
              >
                <label
                  style={{
                    position: 'absolute',
                    top: 6,
                    left: 12,
                    fontSize: 12,
                    color: '#8A8A8A',
                  }}
                >
                  Correo electrónico*
                </label>
                <input
                  type="email"
                  name="email"
                  disabled
                  value={values.email}
                  style={inputStyle}
                />
              </div>

              {/* CELULAR */}
              <div
                style={{
                  position: 'relative',
                  marginBottom: 16,
                  width: '100%',
                }}
              >
                <label
                  style={{
                    position: 'absolute',
                    top: 6,
                    left: 12,
                    fontSize: 12,
                    color: '#8A8A8A',
                  }}
                >
                  Número de celular*
                </label>
                <input
                  type="text"
                  name="celular"
                  disabled
                  value={values.celular}
                  style={inputStyle}
                />
              </div>
              {/* PAÍS */}
              <div
                style={{
                  position: 'relative',
                  marginBottom: 16,
                  width: '100%',
                }}
              >
                <label
                  style={{
                    position: 'absolute',
                    top: 6,
                    left: 12,
                    fontSize: 12,
                    color:
                      errors.pais?.codigo_de_pais &&
                      touched.pais?.codigo_de_pais
                        ? '#FF4D4F'
                        : '#8A8A8A',
                    zIndex: 2,
                  }}
                >
                  País de residencia*
                </label>

                <div style={{ position: 'relative', width: '100%' }}>
                  <select
                    name="pais.codigo_de_pais"
                    value={values.pais?.codigo_de_pais}
                    onChange={e => {
                      const selected = e.target.value;
                      const paisSeleccionado = paises.find(
                        p => p.codigo_de_pais === selected,
                      );

                      setFieldValue('pais.codigo_de_pais', selected);
                      setFieldValue(
                        'pais.descripcion_de_pais',
                        paisSeleccionado?.descripcion_de_pais || '',
                      );
                    }}
                    onBlur={handleBlur}
                    style={{
                      width: '100%',
                      padding: '22px 0px 10px 11px',
                      borderRadius: 6,
                      background: '#F3F3F3',
                      fontSize: 14,
                      boxSizing: 'border-box',
                      appearance: 'none',
                      WebkitAppearance: 'none',
                      MozAppearance: 'none',
                      border:
                        errors.pais?.codigo_de_pais &&
                        touched.pais?.codigo_de_pais
                          ? '1px solid #FF4D4F'
                          : '1px solid #E0E0E0',
                    }}
                  >
                    <option value="">Seleccione</option>

                    {paises?.map(pais => (
                      <option
                        key={pais.codigo_de_pais}
                        value={pais.codigo_de_pais}
                      >
                        {pais.descripcion_de_pais}
                      </option>
                    ))}
                  </select>

                  <span
                    style={{
                      position: 'absolute',
                      right: 14,
                      top: '50%',
                      transform: 'translateY(-35%) rotate(270deg)',
                      fontSize: 20,
                      fontWeight: 900,
                      color:
                        errors.pais?.codigo_de_pais &&
                        touched.pais?.codigo_de_pais
                          ? '#FF4D4F'
                          : '#8A8A8A',
                      pointerEvents: 'none',
                    }}
                  >
                    ‹
                  </span>
                </div>

                {errors.pais?.codigo_de_pais &&
                  touched.pais?.codigo_de_pais && (
                    <small style={{ color: '#FF4D4F' }}>
                      {errors.pais.codigo_de_pais}
                    </small>
                  )}
              </div>

              {/* DEPARTAMENTO */}
              <div
                style={{
                  position: 'relative',
                  marginBottom: 16,
                  width: '100%',
                }}
              >
                <label
                  style={{
                    position: 'absolute',
                    top: 6,
                    left: 12,
                    fontSize: 12,
                    color:
                      errors.departamento?.codigo_departamento &&
                      touched.departamento?.codigo_departamento
                        ? '#FF4D4F'
                        : '#8A8A8A',
                    zIndex: 2,
                  }}
                >
                  Departamento de residencia*
                </label>

                <div style={{ position: 'relative', width: '100%' }}>
                  <select
                    name="departamento.codigo_departamento"
                    value={values.departamento.codigo_departamento}
                    onChange={e => {
                      const selected = e.target.value;

                      setFieldValue(
                        'departamento.codigo_departamento',
                        selected,
                      );

                      const dep = departamentos.find(
                        d => d.codigo === selected,
                      );
                      setFieldValue(
                        'departamento.nombre',
                        dep ? dep.nombre : '',
                      );
                    }}
                    onBlur={handleBlur}
                    style={{
                      width: '100%',
                      padding: '22px 0px 10px 11px',
                      borderRadius: 6,
                      background: '#F3F3F3',
                      fontSize: 14,
                      boxSizing: 'border-box',
                      appearance: 'none',
                      WebkitAppearance: 'none',
                      MozAppearance: 'none',
                      border:
                        errors.departamento?.codigo_departamento &&
                        touched.departamento?.codigo_departamento
                          ? '1px solid #FF4D4F'
                          : '1px solid #E0E0E0',
                    }}
                  >
                    <option value="">Seleccione</option>

                    {departamentos.map(d => (
                      <option key={d.codigo} value={d.codigo}>
                        {d.nombre}
                      </option>
                    ))}
                  </select>

                  <span
                    style={{
                      position: 'absolute',
                      right: 14,
                      top: '50%',
                      transform: 'translateY(-35%) rotate(270deg)',
                      fontSize: 20,
                      fontWeight: 900,
                      color:
                        errors.departamento?.codigo_departamento &&
                        touched.departamento?.codigo_departamento
                          ? '#FF4D4F'
                          : '#8A8A8A',
                      pointerEvents: 'none',
                    }}
                  >
                    ‹
                  </span>
                </div>

                {errors.departamento?.codigo_departamento &&
                  touched.departamento?.codigo_departamento && (
                    <small style={{ color: '#FF4D4F' }}>
                      {errors.departamento.codigo_departamento}
                    </small>
                  )}
              </div>

              {/* PROVINCIA */}
              <div
                style={{
                  position: 'relative',
                  marginBottom: 16,
                  width: '100%',
                }}
              >
                <label
                  style={{
                    position: 'absolute',
                    top: 6,
                    left: 12,
                    fontSize: 12,
                    color:
                      errors.provincia?.codigo_provincia &&
                      touched.provincia?.codigo_provincia
                        ? '#FF4D4F'
                        : '#8A8A8A',
                    zIndex: 2,
                  }}
                >
                  Provincia de residencia*
                </label>

                <div style={{ position: 'relative', width: '100%' }}>
                  <select
                    name="provincia.codigo_provincia"
                    value={values.provincia.codigo_provincia}
                    onChange={e => {
                      const selected = Number(e.target.value);

                      setFieldValue('provincia.codigo_provincia', selected);

                      const prov = provincias.find(p => p.codigo === selected);
                      setFieldValue(
                        'provincia.nombre',
                        prov ? prov.nombre : '',
                      );
                    }}
                    onBlur={handleBlur}
                    disabled={!values.departamento.codigo_departamento}
                    style={{
                      width: '100%',
                      padding: '22px 0px 10px 11px',
                      borderRadius: 6,
                      background: '#F3F3F3',
                      fontSize: 14,
                      boxSizing: 'border-box',
                      appearance: 'none',
                      WebkitAppearance: 'none',
                      MozAppearance: 'none',
                      border:
                        errors.provincia?.codigo_provincia &&
                        touched.provincia?.codigo_provincia
                          ? '1px solid #FF4D4F'
                          : '1px solid #E0E0E0',
                      opacity: !values.departamento.codigo_departamento
                        ? 0.6
                        : 1,
                    }}
                  >
                    <option value="">Seleccione</option>

                    {provincias
                      .filter(
                        p =>
                          p.departamentoCodigo ===
                          Number(values.departamento.codigo_departamento),
                      )
                      .map(p => (
                        <option key={p.codigo} value={p.codigo}>
                          {p.nombre}
                        </option>
                      ))}
                  </select>

                  <span
                    style={{
                      position: 'absolute',
                      right: 14,
                      top: '50%',
                      transform: 'translateY(-35%) rotate(270deg)',
                      fontSize: 20,
                      fontWeight: 900,
                      color:
                        errors.provincia?.codigo_provincia &&
                        touched.provincia?.codigo_provincia
                          ? '#FF4D4F'
                          : '#8A8A8A',
                      pointerEvents: 'none',
                    }}
                  >
                    ‹
                  </span>
                </div>

                {errors.provincia?.codigo_provincia &&
                  touched.provincia?.codigo_provincia && (
                    <small style={{ color: '#FF4D4F' }}>
                      {errors.provincia.codigo_provincia}
                    </small>
                  )}
              </div>

              {/* DISTRITO */}
              <div
                style={{
                  position: 'relative',
                  marginBottom: 16,
                  width: '100%',
                }}
              >
                <label
                  style={{
                    position: 'absolute',
                    top: 6,
                    left: 12,
                    fontSize: 12,
                    color:
                      errors.distrito?.codigo_de_distrito &&
                      touched.distrito?.codigo_de_distrito
                        ? '#FF4D4F'
                        : '#8A8A8A',
                    zIndex: 2,
                  }}
                >
                  Distrito de residencia*
                </label>

                <div style={{ position: 'relative', width: '100%' }}>
                  <select
                    name="distrito.codigo_de_distrito"
                    value={values.distrito.codigo_de_distrito}
                    onChange={e => {
                      const selected = e.target.value;

                      setFieldValue('distrito.codigo_de_distrito', selected);

                      const dist = distritos.find(d => d.codigo === selected);
                      setFieldValue('distrito.nombre', dist ? dist.nombre : '');
                    }}
                    onBlur={handleBlur}
                    disabled={!values.provincia.codigo_provincia}
                    style={{
                      width: '100%',
                      padding: '22px 0px 10px 11px',
                      borderRadius: 6,
                      background: '#F3F3F3',
                      fontSize: 14,
                      boxSizing: 'border-box',
                      appearance: 'none',
                      WebkitAppearance: 'none',
                      MozAppearance: 'none',
                      border:
                        errors.distrito?.codigo_de_distrito &&
                        touched.distrito?.codigo_de_distrito
                          ? '1px solid #FF4D4F'
                          : '1px solid #E0E0E0',
                      opacity: !values.provincia.codigo_provincia ? 0.6 : 1,
                    }}
                  >
                    <option value="">Seleccione</option>

                    {distritos
                      .filter(
                        d =>
                          Number(d.estadoCodigo) ===
                          Number(values.provincia.codigo_provincia),
                      )
                      .map(d => (
                        <option key={d.codigo} value={d.codigo}>
                          {d.nombre}
                        </option>
                      ))}
                  </select>

                  <span
                    style={{
                      position: 'absolute',
                      right: 14,
                      top: '50%',
                      transform: 'translateY(-35%) rotate(270deg)',
                      fontSize: 20,
                      fontWeight: 900,
                      color:
                        errors.distrito?.codigo_de_distrito &&
                        touched.distrito?.codigo_de_distrito
                          ? '#FF4D4F'
                          : '#8A8A8A',
                      pointerEvents: 'none',
                    }}
                  >
                    ‹
                  </span>
                </div>

                {errors.distrito?.codigo_de_distrito &&
                  touched.distrito?.codigo_de_distrito && (
                    <small style={{ color: '#FF4D4F' }}>
                      {errors.distrito.codigo_de_distrito}
                    </small>
                  )}
              </div>

              {/* DIRECCIÓN */}
              <div
                style={{
                  position: 'relative',
                  marginBottom: 16,
                  width: '100%',
                }}
              >
                <label
                  style={{
                    position: 'absolute',
                    top: 6,
                    left: 12,
                    fontSize: 12,
                    color: '#8A8A8A',
                    zIndex: 2,
                  }}
                >
                  Dirección de residencia*
                </label>

                <input
                  type="text"
                  name="direccion"
                  value={values.direccion}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  style={{
                    ...inputStyle,
                    border:
                      touched.direccion && errors.direccion
                        ? '1px solid #FF4D4F'
                        : '1px solid #E0E0E0',
                  }}
                />

                {touched.direccion && errors.direccion && (
                  <small style={{ color: '#FF4D4F' }}>{errors.direccion}</small>
                )}
              </div>

              {/* FECHA NACIMIENTO */}
              <div
                style={{
                  position: 'relative',
                  marginBottom: 16,
                  width: '100%',
                }}
              >
                <label
                  style={{
                    position: 'absolute',
                    top: 6,
                    left: 12,
                    fontSize: 12,
                    color: '#8A8A8A',
                    zIndex: 2,
                  }}
                >
                  Fecha de nacimiento*
                </label>

                <input
                  type="date"
                  name="fecha_nacimiento"
                  value={values.fecha_nacimiento}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  style={{
                    ...inputStyle,
                    border:
                      touched.fecha_nacimiento && errors.fecha_nacimiento
                        ? '1px solid #FF4D4F'
                        : '1px solid #E0E0E0',
                  }}
                />

                {touched.fecha_nacimiento && errors.fecha_nacimiento && (
                  <small style={{ color: '#FF4D4F' }}>
                    {errors.fecha_nacimiento}
                  </small>
                )}
              </div>

              {/* SEXO */}
              <div
                style={{
                  position: 'relative',
                  marginBottom: 16,
                  width: '100%',
                }}
              >
                <label
                  style={{
                    position: 'absolute',
                    top: 6,
                    left: 12,
                    fontSize: 12,
                    color: errors.sexo && touched.sexo ? '#FF4D4F' : '#8A8A8A',
                    zIndex: 2,
                  }}
                >
                  Sexo del Paciente*
                </label>

                <div style={{ position: 'relative', width: '100%' }}>
                  <select
                    name="sexo"
                    value={values.sexo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{
                      width: '100%',
                      padding: '22px 0px 10px 11px',
                      borderRadius: 6,
                      background: '#F3F3F3',
                      fontSize: 14,
                      boxSizing: 'border-box',
                      appearance: 'none',
                      WebkitAppearance: 'none',
                      MozAppearance: 'none',
                      border:
                        errors.sexo && touched.sexo
                          ? '1px solid #FF4D4F'
                          : '1px solid #E0E0E0',
                    }}
                  >
                    <option value="">Seleccione</option>
                    <option value="MASCULINO">Masculino</option>
                    <option value="FEMENINO">Femenino</option>
                  </select>

                  {/* Flecha custom */}
                  <span
                    style={{
                      position: 'absolute',
                      right: 14,
                      top: '50%',
                      transform: 'translateY(-35%) rotate(270deg)',
                      fontSize: 20,
                      fontWeight: 900,
                      color:
                        errors.sexo && touched.sexo ? '#FF4D4F' : '#8A8A8A',
                      pointerEvents: 'none',
                    }}
                  >
                    ‹
                  </span>
                </div>

                {/* MENSAJE DE ERROR */}
                {errors.sexo && touched.sexo && (
                  <small style={{ color: '#FF4D4F' }}>{errors.sexo}</small>
                )}
              </div>

              {/* PASSWORD */}

              <div
                style={{
                  position: 'relative',
                  marginBottom: 16,
                  width: '100%',
                }}
              >
                <label
                  style={{
                    position: 'absolute',
                    top: 6,
                    left: 12,
                    fontSize: 12,
                    color: '#8A8A8A',
                    zIndex: 2,
                  }}
                >
                  Cambiar contraseña
                </label>

                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  style={{
                    ...inputStyle,
                    border:
                      touched.password && errors.password
                        ? '1px solid #FF4D4F'
                        : '1px solid #E0E0E0',
                    paddingRight: 12,
                  }}
                />

                <span
                  onClick={() => setShowPassword(prev => !prev)}
                  style={{
                    position: 'absolute',
                    right: 10,
                    top: touched.password && errors.password ? '30%' : '40%',
                    transform: 'translateY(-20%)',
                    cursor: 'pointer',
                    color: '#8A8A8A',
                    fontSize: 16,
                  }}
                >
                  <i
                    className={`fa-solid ${
                      showPassword ? 'fa-eye' : 'fa-eye-slash'
                    }`}
                  />
                </span>

                {touched.password && errors.password && (
                  <small style={{ color: '#FF4D4F' }}>{errors.password}</small>
                )}
              </div>

              {/* PASSWORD REPEAT */}
              {/* PASSWORD REPEAT */}
              <div
                style={{
                  position: 'relative',
                  marginBottom: 16,
                  width: '100%',
                }}
              >
                <label
                  style={{
                    position: 'absolute',
                    top: 6,
                    left: 12,
                    fontSize: 12,
                    color: '#8A8A8A',
                    zIndex: 2,
                  }}
                >
                  Repetir contraseña
                </label>

                <input
                  type={showRepeatPassword ? 'text' : 'password'}
                  name="password_repeat"
                  value={values.password_repeat}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  style={{
                    ...inputStyle,
                    border:
                      touched.password_repeat && errors.password_repeat
                        ? '1px solid #FF4D4F'
                        : '1px solid #E0E0E0',
                    paddingRight: 12,
                  }}
                />

                <span
                  onClick={() => setShowRepeatPassword(prev => !prev)}
                  style={{
                    position: 'absolute',
                    right: 10,
                    top:
                      touched.password_repeat && errors.password_repeat
                        ? '30%'
                        : '40%',
                    transform: 'translateY(-20%)',
                    cursor: 'pointer',
                    color: '#8A8A8A',
                    fontSize: 16,
                  }}
                >
                  <i
                    className={`fa-solid ${
                      showRepeatPassword ? 'fa-eye' : 'fa-eye-slash'
                    }`}
                  />
                </span>

                {touched.password_repeat && errors.password_repeat && (
                  <small style={{ color: '#FF4D4F' }}>
                    {errors.password_repeat}
                  </small>
                )}
              </div>

              {/* CHECKS */}
              <div style={{ marginBottom: 12 }}>
                <label
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    color:
                      errors.acepta_politicas && touched.acepta_politicas
                        ? '#FF4D4F'
                        : '#333',
                  }}
                >
                  <input
                    type="checkbox"
                    name="acepta_politicas"
                    checked={values.acepta_politicas}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{
                      accentColor:
                        errors.acepta_politicas && touched.acepta_politicas
                          ? '#FF4D4F'
                          : '#144796',
                      cursor: 'pointer',
                    }}
                  />
                  Acepto las{''}
                  <a
                    href="/pdf/politicadeprivacidad.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {'políticas de privacidad de datos'}
                  </a>
                </label>

                {errors.acepta_politicas && touched.acepta_politicas && (
                  <small
                    style={{
                      color: '#FF4D4F',
                      display: 'block',
                      marginLeft: 24,
                    }}
                  >
                    {errors.acepta_politicas}
                  </small>
                )}
              </div>

              <div style={{ marginBottom: 24 }}>
                <label>
                  <input
                    type="checkbox"
                    name="acepta_publicidad"
                    checked={values.acepta_publicidad}
                    onChange={handleChange}
                  />{' '}
                  Acepto recibir{' '}
                  <a
                    href="/pdf/Acep_ben_of_pu_nes_2025.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ marginLeft: 4 }}
                  >
                    ofertas, publicidad y novedades (Opcional)
                  </a>
                </label>
              </div>

              <button
                type="submit"
                className="btnPrimary width100 fontWhite"
                style={{
                  height: 48,
                  background: '#023B7A',
                  border: '1px solid #E0E0E0',
                  borderRadius: 6,
                }}
              >
                GUARDAR / ACTUALIZAR DATOS
              </button>
              {successMessage && (
                <div style={{ color: 'green', marginTop: 10 }}>
                  {successMessage}
                </div>
              )}

              {errorMessage && (
                <div style={{ color: 'red', marginTop: 10 }}>
                  {errorMessage}
                </div>
              )}
            </Form>
          )}
        </Formik>
      </FlexContainer>
    </div>
  );
};

export default PatientDataView;
